import angular from 'angular';
import uiRouter from 'angular-ui-router';
import specialtiesComponent from './specialties.component';

let specialtiesModule = angular.module('specialties', [
  uiRouter
])

.component('specialties', specialtiesComponent);

export default specialtiesModule;



// WEBPACK FOOTER //
// ./client/app/common/admin/specialties/specialties.js